import { Translation } from '@ps/web-shared-components';
import React from 'react';

import StepThree from '../../../../assets/icons/activestep3.svg';
import CompletedStepIcon from '../../../../assets/icons/completedstep.svg';
import FutureStepBonus from '../../../../assets/icons/futurestepbonus.svg';

import { TXTWCL_Deposit_66 } from './StepThreeActive.messages.json';

interface StepThreeActiveProps {
  classname: string;
}

const StepThreeActive = ({ classname }: StepThreeActiveProps) => (
  <>
    <CompletedStepIcon />
    <CompletedStepIcon />
    <div className={classname}>
      <StepThree />
      <p>
        <Translation {...TXTWCL_Deposit_66} />
      </p>
    </div>
    <FutureStepBonus />
  </>
);

export default StepThreeActive;
